import unauthorizedRedirect from "~/components/utilities/unauthorizedRedirect";

const saveForDiscussion = async function saveForDiscussion() {
  this.showErrors = true;

  await this.$store.dispatch("validateDiscussion");

  if (this.errors && this.errors.length > 0) {
    return;
  }

  try {
    return await this.$store.dispatch("createDiscussion");
  } catch (error) {
    if (
      error.status &&
      error.status.find((err) => err.message === "Access Denied")
    ) {
      unauthorizedRedirect(
        this.$router.replace,
        this.$isServer,
        this.$config,
        undefined
      );
    } else {
      throw error;
    }
  }
};

export default saveForDiscussion;
